import { isEqual } from "lodash-es";

import { useInverseGatedValue } from "./useGatedValue";

export function useDeepEqual<T>(value: T): T {
    return useInverseGatedValue(value, isEqual);
}
